import { useEffect, useMemo, useState } from "react";
import { Close, ExpandLess, ExpandMore, Search } from "@mui/icons-material";
import { Collapse, Grid, Icon, IconButton, List, ListItem } from "@mui/material";

import Helpers from "../../commons/helpers";

import { icon, listItem } from "./styles";
import { IMenuItem } from "../../commons/interfaces";
import { Box, TextField, Typography } from "@maysoft/common-component-react";
import { useCommunityCommonContext } from "../../providers/CommunityCommonProvider";

const CommunityMenuBar = () => {
    const props = useCommunityCommonContext();

    const mainRoutes = useMemo(() => props.routes, [props.routes]);

    const pathNameCurrent: string = useMemo(() => props.pathNameCurrent || "", [props.pathNameCurrent]);

    const [arrKeySelected, setArrKeySelected] = useState<string[]>([]);
    const [arrKeyOnClicked, setArrKeyOnClicked] = useState<string[]>([]);

    const [searchText, setSearchText] = useState<string | undefined | null>(undefined);

    let valueSelected: string[] = [];

    useEffect(() => {
        setSearchText(props.searchText);
    }, [props.searchText]);

    useEffect(() => {
        const arrPathname = pathNameCurrent.split("/").slice(1);
        if (arrPathname.length > 0) {
            onCheckItem(arrPathname, mainRoutes || [], 0);
            setArrKeySelected(valueSelected);
            setArrKeyOnClicked(valueSelected);
        }
    }, [mainRoutes, pathNameCurrent]);

    const onCheckItem = (arrPathname: string[], dataMenu: IMenuItem[], index: number) => {
        const itemParent = dataMenu.find((el) => el.screenPath === pathNameCurrent);

        if (itemParent) {
            const keyValue = !itemParent?.isVisible ? arrPathname[index] : itemParent?.key;
            valueSelected.push(keyValue);
        } else {
            const itemFinded = dataMenu.find((el) => el.key === arrPathname[index]);
            const keyValue = !itemFinded?.isVisible ? arrPathname[index] : itemFinded?.key;

            valueSelected.push(keyValue);

            if ((itemFinded?.subMenu || []).length > 0) {
                onCheckItem(arrPathname, itemFinded?.subMenu || [], index + 1);
            }
        }
    };

    const handelOnClickItem = (dataMenu: IMenuItem) => {
        if ([...(dataMenu?.subMenu || [])].length === 0) {
            Helpers.isNullOrEmpty(dataMenu?.target)
                ? props.onNavigate(dataMenu?.screenPath)
                : props.onNavigate(`${dataMenu?.screenPath}`, `${dataMenu?.target}`);
        } else {
            const arrItemTemp: string[] = [...(arrKeyOnClicked || [])];
            if (arrItemTemp.findIndex((el) => el === dataMenu?.key) === -1) {
                setArrKeyOnClicked([dataMenu?.key]);
            } else {
                const temp = arrItemTemp.filter((el) => el !== dataMenu?.key);
                setArrKeyOnClicked(temp);
            }
        }
    };

    const handelKeyActiveSelected = (keyItem: string) => {
        const valueTemp = arrKeySelected.find((el) => keyItem.includes(el));
        return valueTemp ? true : false;
    };

    const handelKeyActiveOnClicked = (keyItem: string) => {
        const valueTemp = arrKeyOnClicked.find((el) => keyItem.includes(el));
        return valueTemp ? true : false;
    };

    const renderIconItemMenu = (dataMenu: IMenuItem) => {
        if (!dataMenu?.hidenIcon) {
            if (Helpers.isNullOrEmpty(dataMenu?.icon) && Helpers.isNullOrEmpty(dataMenu?.iconName)) {
                return <Box sx={icon}></Box>;
            } else {
                if (!Helpers.isNullOrEmpty(dataMenu?.iconName)) {
                    return <Icon sx={{ fontWeight: "bold", marginRight: 1 }}>{dataMenu?.iconName}</Icon>;
                }

                if (!Helpers.isNullOrEmpty(dataMenu?.icon)) {
                    return <Box sx={icon}>{dataMenu?.icon}</Box>;
                }

                return <Box sx={icon}></Box>;
            }
        } else {
            return <Box sx={icon}></Box>;
        }
    };

    const renderItemMenu = (dataMenu: IMenuItem, level?: number) => (
        <ListItem
            key={dataMenu?.key}
            sx={{
                py: 1,
                display: dataMenu?.isVisible ? "block" : "none",
            }}
        >
            <IconButton
                onClick={() => handelOnClickItem(dataMenu)}
                sx={(theme) =>
                    listItem(theme, {
                        isActive: handelKeyActiveSelected(dataMenu?.key) ? true : false,
                    })
                }
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginLeft: level > 0 ? level : 0,
                    }}
                >
                    {renderIconItemMenu(dataMenu)}
                    <Typography
                        color="dark"
                        variant="button"
                        fontWeight="bold"
                        sx={{
                            pl: "8px",
                            maxWidth: "150px",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {dataMenu?.title}
                    </Typography>
                </Box>
            </IconButton>
        </ListItem>
    );

    const renderItemMenuHaveSubMenu = (dataMenu: IMenuItem) => (
        <Box style={{ display: dataMenu?.isVisible ? "block" : "none" }} key={dataMenu?.key}>
            <ListItem style={{ paddingBottom: "4px", paddingTop: "4px" }}>
                <IconButton
                    onClick={() => {
                        handelOnClickItem(dataMenu);
                    }}
                    sx={(theme) =>
                        listItem(theme, {
                            isParent: true,
                            isActive: handelKeyActiveSelected(dataMenu?.key) ? true : false,
                        })
                    }
                >
                    <Box
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        {renderIconItemMenu(dataMenu)}
                        <Typography
                            color="dark"
                            variant="button"
                            fontWeight="bold"
                            sx={{
                                pl: "8px",
                                maxWidth: "150px",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {dataMenu?.title}
                        </Typography>
                    </Box>
                    {handelKeyActiveOnClicked(dataMenu?.key) ? <ExpandLess htmlColor={"#344767"} /> : <ExpandMore htmlColor={"#344767"} />}
                </IconButton>
            </ListItem>
            <Collapse in={handelKeyActiveOnClicked(dataMenu?.key)} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {[...(dataMenu.subMenu || [])].map((itemSubMenu) => renderItemMenu(itemSubMenu))}
                </List>
            </Collapse>
        </Box>
    );

    return (
        <Grid
            sx={{
                display: "flex",
                minHeight: "100%",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
        >
            <List>
                {/* Search Text */}
                {Helpers.isFunction(props.onSearch) && (
                    <ListItem sx={{ py: 1 }}>
                        <Box p={0}>
                            <TextField
                                fullWidth
                                size="small"
                                maxLength={255}
                                key={searchText}
                                variant="outlined"
                                plplaceholder="Search"
                                defaultValue={searchText || ""}
                                onBlur={(e: any) => {
                                    setSearchText(e.target.value);
                                }}
                                onKeyPress={(e: any) => {
                                    if (e.key === "Enter") {
                                        setSearchText(e.target.value);
                                        props.onSearch(e.target.value);
                                    }
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <IconButton
                                            color="info"
                                            onClick={() => {
                                                props.onSearch(searchText);
                                            }}
                                        >
                                            <Search />
                                        </IconButton>
                                    ),
                                    endAdornment: !Helpers.isNullOrEmpty(searchText) && (
                                        <IconButton
                                            color="secondary"
                                            onClick={() => {
                                                setSearchText("");
                                                props.onSearch("");
                                            }}
                                        >
                                            <Close />
                                        </IconButton>
                                    ),
                                }}
                            />
                        </Box>
                    </ListItem>
                )}

                {mainRoutes.map((menuItem) => {
                    if ([...(menuItem?.subMenu || [])].length === 0) {
                        return renderItemMenu(menuItem);
                    } else {
                        return renderItemMenuHaveSubMenu(menuItem);
                    }
                })}
            </List>
        </Grid>
    );
};

export default CommunityMenuBar;
